import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { StyledChatItem } from './ChatItem.style';


const ChatSkeleton = () => {
  return (
    <StyledChatItem className='chat-item skeleton'>
      <div className='chat-item__inner'>
        <div className='chat-item__img-wrapper'>
          <Skeleton height={'100%'} width={'100%'} style={{ margin: 0, padding: 0, lineHeight: 1 }} />
        </div>
        <div className='chat-item__text-wrapper'>
          <div className='chat-item__title-wrapper'>
            <h5 className='chat-item__title' style={{ width: '95%' }}>
              <Skeleton count={1} height={18} />
            </h5>
          </div>
          <p className='chat-item__description'>
            <Skeleton count={1} height={18} width={'60%'} />
          </p>
        </div>
      </div>
    </StyledChatItem>
  );
}

export default ChatSkeleton;
